export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=tech.innercompass.app";
export const ANDROID_PACKAGE = "tech.innercompass.app";

/** Coarse, privacy-safe platform detection from the user agent only (no fingerprinting, nothing stored). */
export function detectPlatform() {
  if (typeof navigator === "undefined") return "desktop";
  const ua = navigator.userAgent || "";
  if (/android/i.test(ua)) return "android";
  const iosUA = /iPad|iPhone|iPod/.test(ua);
  const iPadOS = navigator.platform === "MacIntel" && (navigator.maxTouchPoints || 0) > 1;
  if (iosUA || iPadOS) return "ios";
  return "desktop";
}

const KEY = "ic_app_prompt_dismissed";

export const isPromptDismissed = () => {
  try { return sessionStorage.getItem(KEY) === "1"; } catch { return false; }
};
export const dismissPrompt = () => {
  try { sessionStorage.setItem(KEY, "1"); } catch {}
};
